import { Injectable } from '@angular/core';
import { FileDto } from '@shared/service-proxies/service-proxies';
import { AppConsts } from '@shared/AppConsts';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http'


@Injectable()
export class FileDownloadService {

    constructor(private http: HttpClient) { }
    downloadTempFile(file: FileDto) {
        const url = AppConsts.remoteServiceBaseUrl + '/File/DownloadTempFile?fileType=' + file.fileType + '&fileToken=' + file.fileToken + '&fileName=' + file.fileName;
        location.href = url; //TODO: This causes reloading of same page in Firefox
    }

    uploadFile(data: FormData) {
        var url = AppConsts.remoteServiceBaseUrl + "/api/services/app/ImportData/ImportFromExcel";
        const uploadReq = new HttpRequest('POST', url, data);
        this.http.request(uploadReq).subscribe(event => {
        });

    }
}



// WEBPACK FOOTER //
// ./src/shared/utils/file-download.service.ts